export const CampaignStatus = {
  Draft: 'Draft',
  Approved: 'Approved',
  Sent: 'Sent',
  Scheduled: 'Scheduled',
};
